module.exports = __webpack_public_path__ + "media/images/icons/pencil-6a9e5a344cf8b53d768bf7231e6cc40c.svg";